import React from 'react';
import { Box, Typography, Slider } from '@mui/joy';

interface Props {
  rating: number;
  onChange: (value: number) => void;
}

const RatingSlider: React.FC<Props> = ({ rating, onChange }) => {
  return (
    <Box>
      <Box display="flex" justifyContent="space-between">
        <Typography level="label">Rating</Typography>
        <Typography level="label">{rating}</Typography>
      </Box>
      <Slider
        value={rating}
        onChange={(e, value) => onChange(value as number)}
        step={1}
        min={0}
        max={5}
      />
    </Box>
  );
};

export default RatingSlider;
